import type { PartnerOverviewAttribute, PartnerTierOption, PartnerTypeOption } from './partner-overview-attribute.types';

export const PARTNER_OVERVIEW_SCOPE_ALL = 'All';

export const PARTNER_OVERVIEW_ATTRIBUTE_LIMIT = 20;

/**
 * @description Tier choices for an attribute. Single-select and deliberately without an "All"
 * entry: the tier decides whether the type picker offers Product Types or Component Types, so an
 * "all tiers" attribute would have no single type list to draw from.
 */
export const PARTNER_OVERVIEW_TIER_OPTIONS: PartnerTierOption[] = [
  { _id: 'Tier1', name: 'Tier 1' },
  { _id: 'Tier2', name: 'Tier 2' },
  { _id: 'Tier3', name: 'Tier 3' },
  { _id: 'Tier4', name: 'Tier 4' },
];

/**
 * @description Surfaces every attribute is written to. There is no per-attribute choice: supplier
 * and factory share one pool of PARTNER_OVERVIEW_ATTRIBUTE_LIMIT attributes.
 */
export const PARTNER_OVERVIEW_DEFAULT_SURFACES = ['supplier', 'factory'];

export const PARTNER_OVERVIEW_TYPE_OPTIONS: PartnerTypeOption[] = [
  { name: 'Dropdown', value: 'dropdown' },
  { name: 'Multi Select Dropdown', value: 'multi-dropdown' },
  { name: 'Text Box', value: 'text' },
  { name: 'Date Picker', value: 'date-picker' },
];

export const PARTNER_OVERVIEW_TIER_ONE = 'Tier1';

export const PARTNER_OVERVIEW_COMPONENT_TIERS = ['Tier2', 'Tier3', 'Tier4'];

export const PARTNER_OVERVIEW_TEXT_CHAR_LIMIT_DEFAULT = 50;

/**
 * @description Blank attribute used when the admin adds a new row. Scope arrays start empty so
 * the required-scope validation fires until the admin chooses, matching the product master.
 */
export const emptyAttribute = (type: string): PartnerOverviewAttribute => ({
  _id: '',
  keyName: '',
  aliasName: '',
  type,
  tierType: [],
  supplierType: [],
  appliesTo: PARTNER_OVERVIEW_DEFAULT_SURFACES,
  options: [],
  textFieldConfig: { charLimit: PARTNER_OVERVIEW_TEXT_CHAR_LIMIT_DEFAULT, isEditable: true },
  isActive: true,
  isNew: true,
  isEmpty: false,
});

/**
 * @description True when the attribute type carries a selectable option list.
 */
export const hasOptions = (type?: string): boolean => type === 'dropdown' || type === 'multi-dropdown';
